import { Box, BoxProps } from '@mui/material';

interface TabPanelProps extends BoxProps {
  value: number;
  selectedTab: number;
}

export const TabPanel = (props: TabPanelProps) => {
  const { children, value, selectedTab, ...other } = props;

  return (
    <Box
      id={`tabPanel${value}`}
      role='tabpanel'
      aria-labelledby={`tab${value}`}
      hidden={selectedTab !== value}
      {...other}
      sx={[
        {
          height: '100%',
        },
        ...(Array.isArray(other.sx) ? other.sx : [other.sx]),
      ]}
    >
      {selectedTab === value ? children : null}
    </Box>
  );
};
